import { createContext, ReactNode } from 'react';

/* @internal */
export interface TabNavigationSpec {
	readonly removed: boolean;
	readonly label: string;
	readonly value: string;
	readonly hiddenLabel: string | null;
	readonly trailingSlot: ReactNode | null;
	readonly disabled: boolean;
}

interface TabNavigationContextState {
	readonly tabs: TabNavigationSpec[];
	readonly activeTab: string | undefined;
	changeTab(tab: string): void;
	registerTab(spec: TabNavigationSpec): void;
	unregisterTab(tab: string): void;
}

/* @internal */
export const TabNavigationContext = createContext<TabNavigationContextState>(undefined as unknown as TabNavigationContextState);
